import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { apiRequest } from "./chatbotApi";

// Interval polling (ms). Diekspor supaya bisa dipercepat saat pengujian.
export const inboxConfig = { listPollMs: 5000, chatPollMs: 3000 };

const C = {
  ink: "#172A25",
  indigo: "#087E68",
  sand: "#EAF3EF",
  paper: "#F5F8F6",
  line: "#E3EBE7",
  muted: "#788A83",
  soft: "#53665F",
  green: "#16845E",
  greenBg: "#E5F4ED",
  amber: "#9A6A12",
  amberBg: "#FFF4DB",
  agent: "#087E68",
  danger: "#B4472B",
  dangerBg: "#FBEAE5",
};

const CHAT_STATUS_OPTIONS = [
  { value: "open", label: "Terbuka" },
  { value: "pending", label: "Menunggu" },
  { value: "resolved", label: "Selesai" },
];

const CHAT_EMOJIS = [
  "😀", "😃", "😄", "😁", "😆", "😅", "😂", "🙂", "🙃", "😉",
  "😊", "😍", "🥰", "😘", "😋", "😎", "🤔", "🤗", "😭", "😢",
  "😡", "👍", "👎", "👏", "🙏", "🤝", "💪", "👌", "✌️", "👋",
  "❤️", "💚", "💙", "💯", "🔥", "🎉", "✨", "✅", "⭐", "💐",
  "☀️", "🌹", "🍰", "☕", "🎂", "📦", "📍", "💬", "🙌", "🤩",
];
const MAX_ATTACHMENT_BYTES = 16 * 1024 * 1024;
const ATTACHMENT_ACCEPT = "image/jpeg,image/png,image/gif,image/webp,.pdf,.txt,.csv,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.zip";

const INBOX_STYLES = `
  .ib-shell {
    width: 100%; height: 100vh; height: 100dvh; min-height: 0;
    display: grid; grid-template-columns: 62px minmax(290px, 23vw) minmax(0, 1fr) minmax(270px, 22vw);
    overflow: hidden; background: #fff; color: ${C.ink};
    font-family: 'Inter', sans-serif;
  }
  .ib-nav { position: relative; z-index: 20; display: flex; flex-direction: column; align-items: center; gap: 10px; box-sizing: border-box; width: 62px; padding: 14px 8px; background: #102E29; color: #DCEAE4; transition: width .2s ease, box-shadow .2s ease; }
  .ib-nav:hover, .ib-nav:focus-within { width: 220px; align-items: stretch; box-shadow: 8px 0 24px rgba(16,46,41,.16); }
  .ib-nav-logo { display: flex; align-items: center; justify-content: center; flex: 0 0 38px; width: 38px; margin-bottom: 12px; border-radius: 12px; background: #16A078; color: white; font-size: 11px; font-weight: 800; }
  .ib-nav-btn { display: flex; align-items: center; justify-content: center; gap: 12px; flex: 0 0 42px; width: 42px; padding: 0; border: 0; border-radius: 12px; background: transparent; color: #B5CDC3; cursor: pointer; font: inherit; font-size: 19px; transition: background .16s ease, color .16s ease, width .2s ease; }
  .ib-nav-icon { display: grid; place-items: center; flex: 0 0 42px; }
  .ib-nav-label { max-width: 0; overflow: hidden; opacity: 0; color: #DCEAE4; font-size: 12px; font-weight: 600; text-align: left; text-overflow: ellipsis; white-space: nowrap; transition: max-width .2s ease, opacity .15s ease; }
  .ib-nav:hover .ib-nav-btn, .ib-nav:focus-within .ib-nav-btn { justify-content: flex-start; width: 100%; }
  .ib-nav:hover .ib-nav-label, .ib-nav:focus-within .ib-nav-label { max-width: 160px; opacity: 1; }
  .ib-nav:hover .ib-nav-logo, .ib-nav:focus-within .ib-nav-logo { justify-content: flex-start; width: auto; padding: 0 12px; gap: 12px; }
  .ib-nav-btn:hover, .ib-nav-btn[aria-current="page"] { background: #1D5146; color: white; }
  .ib-nav-spacer { flex: 1; }
  .ib-nav-user { display: grid; place-items: center; width: 36px; height: 36px; border-radius: 50%; background: #DDEEE6; color: #145B49; font-weight: 700; }
  .ib-list { display: flex; flex-direction: column; min-height: 0; background: ${C.paper}; border-right: 1px solid ${C.line}; }
  .ib-chat { display: flex; flex-direction: column; min-width: 0; min-height: 0; background: #fff; }
  .ib-profile { display: flex; flex-direction: column; min-width: 0; min-height: 0; overflow-y: auto; border-left: 1px solid ${C.line}; background: #fff; }
  .ib-profile-cover { position: relative; height: 145px; flex: 0 0 145px; background: linear-gradient(135deg, #B9E5D2, #6AB99B 55%, #3E9B7B); }
  .ib-profile-avatar { position: absolute; left: 22px; bottom: -34px; display: grid; place-items: center; width: 76px; height: 76px; border: 5px solid white; border-radius: 50%; color: white; font-size: 28px; font-weight: 700; box-shadow: 0 3px 12px rgba(20,50,40,.12); }
  .ib-profile-body { padding: 46px 20px 24px; }
  .ib-profile-title { margin: 0 0 4px; color: ${C.ink}; font-size: 18px; font-weight: 700; overflow-wrap: anywhere; }
  .ib-profile-subtitle { margin-bottom: 20px; color: ${C.muted}; font-size: 12px; }
  .ib-profile-section { padding: 15px 0; border-top: 1px solid ${C.line}; }
  .ib-profile-section-title { margin-bottom: 12px; color: ${C.soft}; font-size: 11px; font-weight: 700; letter-spacing: .08em; text-transform: uppercase; }
  .ib-profile-control-label { display: block; margin-bottom: 7px; color: ${C.muted}; font-size: 12px; font-weight: 500; letter-spacing: 0; text-transform: none; }
  .ib-profile-notes-title { display: block; }
  .ib-profile-row { display: flex; justify-content: space-between; gap: 12px; padding: 7px 0; font-size: 12.5px; }
  .ib-profile-label { color: ${C.muted}; flex: 0 0 auto; }
  .ib-profile-value { color: ${C.ink}; font-weight: 600; text-align: right; overflow-wrap: anywhere; }
  .ib-profile-pill { display: inline-flex; align-items: center; gap: 6px; padding: 6px 10px; border-radius: 999px; background: ${C.greenBg}; color: ${C.green}; font-size: 11px; font-weight: 600; }
  .ib-profile-control { width: 100%; min-height: 40px; padding: 8px 10px; border: 1px solid ${C.line}; border-radius: 9px; background: ${C.paper}; color: ${C.ink}; font: inherit; font-size: 12.5px; }
  .ib-profile-notes { display: block; min-height: 110px; resize: vertical; line-height: 1.5; }
  .ib-profile-save { display: inline-flex; align-items: center; justify-content: center; min-height: 36px; margin-top: 9px; padding: 7px 12px; border: 0; border-radius: 9px; background: ${C.indigo}; color: #fff; font: inherit; font-size: 12px; font-weight: 600; cursor: pointer; }
  .ib-profile-save:disabled { opacity: .55; cursor: default; }
  .ib-profile-feedback { margin-top: 8px; color: ${C.muted}; font-size: 11.5px; line-height: 1.45; }
  .ib-profile-error { margin-top: 8px; color: ${C.danger}; font-size: 12px; line-height: 1.45; }
  .ib-profile-empty { display: flex; flex: 1; align-items: center; justify-content: center; padding: 24px; color: ${C.muted}; text-align: center; font-size: 13px; line-height: 1.6; }
  .ib-analytics { min-width: 0; min-height: 0; overflow-y: auto; padding: 28px clamp(20px, 3vw, 48px); background: #fff; }
  .ib-report { min-width: 0; min-height: 0; overflow: auto; padding: 28px clamp(20px, 3vw, 48px); background: #fff; }
  .ib-report-header { display: flex; align-items: center; justify-content: space-between; gap: 20px; padding-bottom: 18px; border-bottom: 1px solid ${C.line}; }
  .ib-report-title { margin: 0; color: ${C.ink}; font-size: 28px; letter-spacing: -.04em; }
  .ib-report-subtitle { margin: 6px 0 0; color: ${C.muted}; font-size: 13px; }
  .ib-report-filter { display: flex; align-items: end; flex-wrap: wrap; gap: 12px; padding: 18px 0; }
  .ib-report-filter label { display: grid; gap: 6px; color: ${C.soft}; font-size: 12px; }
  .ib-report-control { min-height: 42px; padding: 8px 12px; border: 1px solid ${C.line}; border-radius: 10px; background: ${C.paper}; color: ${C.ink}; font: inherit; }
  .ib-report-export { min-height: 42px; padding: 9px 15px; border: 0; border-radius: 10px; background: ${C.indigo}; color: #fff; font: inherit; font-weight: 600; cursor: pointer; }
  .ib-report-export:disabled { opacity: .55; cursor: default; }
  .ib-report-count { margin: 0 0 12px; color: ${C.muted}; font-size: 13px; }
  .ib-report-table-wrap { overflow: auto; border: 1px solid ${C.line}; border-radius: 12px; }
  .ib-report-table { width: 100%; border-collapse: collapse; text-align: left; }
  .ib-report-table th { position: sticky; top: 0; z-index: 1; padding: 12px 14px; background: ${C.paper}; color: ${C.soft}; font-size: 11px; letter-spacing: .04em; text-transform: uppercase; white-space: nowrap; }
  .ib-report-table td { min-width: 120px; padding: 13px 14px; border-top: 1px solid ${C.line}; color: ${C.ink}; font-size: 13px; vertical-align: top; }
  .ib-report-table td:last-child { min-width: 280px; max-width: 520px; line-height: 1.55; white-space: pre-wrap; overflow-wrap: anywhere; }
  .ib-report-empty { padding: 36px 20px; color: ${C.muted}; text-align: center; font-size: 13px; }
  .ib-report-error { margin: 12px 0; padding: 12px 14px; border-radius: 10px; background: ${C.dangerBg}; color: ${C.danger}; font-size: 13px; }
  .ib-analytics-header { display: flex; align-items: center; justify-content: space-between; gap: 20px; padding-bottom: 18px; border-bottom: 1px solid ${C.line}; }
  .ib-analytics-title { margin: 0; font-size: 28px; letter-spacing: -.04em; color: ${C.ink}; }
  .ib-analytics-tabs { display: flex; gap: 8px; align-self: stretch; margin-left: 24px; }
  .ib-analytics-tab { padding: 8px 14px; border: 0; border-bottom: 2px solid transparent; background: transparent; color: ${C.soft}; font: inherit; cursor: pointer; white-space: nowrap; }
  .ib-analytics-tab[aria-pressed="true"] { border-color: ${C.indigo}; color: ${C.indigo}; font-weight: 600; }
  .ib-analytics-filter { display: flex; align-items: center; flex-wrap: wrap; gap: 10px; padding: 18px 0 22px; }
  .ib-analytics-control { min-height: 42px; padding: 8px 12px; border: 1px solid ${C.line}; border-radius: 10px; background: ${C.paper}; color: ${C.ink}; font: inherit; }
  .ib-analytics-grid { display: grid; grid-template-columns: repeat(6, minmax(0, 1fr)); gap: 18px; padding-bottom: 24px; }
  .ib-analytics-card { grid-column: span 3; min-width: 0; min-height: 280px; padding: 20px; border: 1px solid #E6EBF2; border-radius: 16px; background: #fff; box-shadow: 0 3px 14px rgba(26,42,63,.035); }
  .ib-analytics-card.third { grid-column: span 2; min-height: 230px; }
  .ib-analytics-card.full { grid-column: 1 / -1; }
  .ib-analytics-card-title { margin: 0 0 8px; font-size: 16px; font-weight: 600; color: ${C.ink}; }
  .ib-analytics-total { margin-bottom: 12px; color: ${C.ink}; font-size: 23px; font-weight: 600; }
  .ib-analytics-total span { margin-left: 6px; color: ${C.muted}; font-size: 13px; font-weight: 400; }
  .ib-chart { display: block; width: 100%; height: 190px; overflow: visible; }
  .ib-chart-grid { stroke: #E8EDF2; stroke-width: 1; }
  .ib-chart-label { fill: #768292; font-size: 11px; }
  .ib-chart-line { fill: none; stroke: #4F7FE3; stroke-width: 3; stroke-linecap: round; stroke-linejoin: round; }
  .ib-chart-line.secondary { stroke: #24A879; }
  .ib-chart-dot { fill: #4F7FE3; stroke: white; stroke-width: 2; }
  .ib-chart-dot.secondary { fill: #24A879; }
  .ib-chart-legend { display: flex; flex-wrap: wrap; gap: 14px; color: ${C.soft}; font-size: 12px; }
  .ib-chart-legend span { display: inline-flex; align-items: center; gap: 6px; }
  .ib-chart-legend i { width: 9px; height: 9px; border-radius: 50%; background: #4F7FE3; }
  .ib-chart-legend i.secondary { background: #24A879; }
  .ib-analytics-bars { display: flex; flex-direction: column; gap: 16px; margin-top: 20px; }
  .ib-analytics-bar-row { display: grid; grid-template-columns: minmax(75px, 1fr) 3fr auto; align-items: center; gap: 12px; color: ${C.soft}; font-size: 12px; }
  .ib-analytics-bar-track { height: 10px; overflow: hidden; border-radius: 99px; background: ${C.paper}; }
  .ib-analytics-bar { height: 100%; border-radius: inherit; background: #55B7A1; }
  .ib-analytics-empty { display: grid; place-items: center; min-height: 170px; padding: 20px; color: ${C.muted}; text-align: center; font-size: 13px; line-height: 1.6; }
  .ib-analytics-error { margin: 8px 0 16px; padding: 12px 14px; border-radius: 10px; background: ${C.dangerBg}; color: ${C.danger}; }
  .ib-scroll { overflow-y: auto; min-height: 0; }
  .ib-scroll::-webkit-scrollbar { width: 7px; }
  .ib-scroll::-webkit-scrollbar-thumb { background: #D4E1DA; border: 2px solid transparent; border-radius: 8px; background-clip: padding-box; }
  .ib-item {
    display: flex; gap: 13px; width: 100%; text-align: left; padding: 15px 18px;
    border: none; border-bottom: 1px solid #EAF0EC; background: transparent;
    cursor: pointer; font: inherit; color: inherit; transition: background .16s ease, box-shadow .16s ease;
  }
  .ib-item:hover { background: #EAF2ED; }
  .ib-item[aria-current="true"] { background: #fff; box-shadow: inset 4px 0 0 ${C.indigo}; }
  .ib-focusable { transition: border-color .16s ease, box-shadow .16s ease, background .16s ease; }
  .ib-focusable:focus { border-color: ${C.indigo}; box-shadow: 0 0 0 3px rgba(8,126,104,.12); }
  .ib-focusable:focus-visible { outline: 2px solid #4A3B5C; outline-offset: 2px; }
  .ib-item:focus-visible { outline-offset: -2px; }
  .ib-emoji-picker { display: grid; grid-template-columns: repeat(8, minmax(0, 1fr)); gap: 4px; max-width: 360px; max-height: 190px; overflow-y: auto; margin-bottom: 10px; padding: 10px; border: 1px solid ${C.line}; border-radius: 12px; background: #fff; box-shadow: 0 8px 24px rgba(23,42,37,.12); }
  .ib-emoji-button { display: grid; place-items: center; min-width: 34px; min-height: 34px; padding: 2px; border: 0; border-radius: 8px; background: transparent; font-size: 21px; cursor: pointer; }
  .ib-emoji-button:hover { background: ${C.sand}; }
  .ib-attachment-preview { display: flex; align-items: center; justify-content: space-between; gap: 10px; max-width: 440px; margin-bottom: 10px; padding: 8px 10px; border: 1px solid ${C.line}; border-radius: 10px; background: ${C.paper}; color: ${C.soft}; font-size: 12px; }
  .ib-attachment-name { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .ib-attachment-remove { flex: 0 0 auto; border: 0; background: transparent; color: ${C.muted}; font-size: 18px; cursor: pointer; }
  .ib-bubble-attachment { margin: 4px 0 8px; }
  .ib-bubble-image { display: block; width: min(100%, 300px); max-height: 300px; object-fit: cover; border-radius: 10px; }
  .ib-bubble-file { display: inline-block; max-width: 100%; padding: 8px 10px; border-radius: 9px; background: rgba(0,0,0,.06); color: inherit; overflow-wrap: anywhere; text-decoration: none; }
  .ib-back { display: none; }
  .ib-sr { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap; }
  @keyframes ib-pulse { 0%, 100% { opacity: 0.35; } 50% { opacity: 1; } }
  .ib-pulse { animation: ib-pulse 1.4s ease-in-out infinite; }
  @media (prefers-reduced-motion: reduce) { .ib-pulse { animation: none; } }
  @media (max-width: 1000px) {
    .ib-shell { grid-template-columns: 58px minmax(270px, 30vw) minmax(0, 1fr); }
    .ib-profile { display: none; }
  }
  .ib-shell[data-page="analytics"], .ib-shell[data-page="customer-report"] { grid-template-columns: 62px minmax(0, 1fr); }
  @media (max-width: 700px) {
    .ib-shell { grid-template-columns: 1fr; height: 100vh; height: 100dvh; }
    .ib-shell[data-page="analytics"], .ib-shell[data-page="customer-report"] { grid-template-columns: 1fr; grid-template-rows: minmax(0, 1fr) 58px; }
    .ib-nav { display: none; }
    .ib-shell[data-page="analytics"] .ib-nav, .ib-shell[data-page="customer-report"] .ib-nav { grid-row: 2; display: flex; flex-direction: row; justify-content: space-around; width: 100%; height: 58px; padding: 6px 12px; }
    .ib-shell[data-page="analytics"] .ib-nav:hover, .ib-shell[data-page="analytics"] .ib-nav:focus-within,
    .ib-shell[data-page="customer-report"] .ib-nav:hover, .ib-shell[data-page="customer-report"] .ib-nav:focus-within { width: 100%; align-items: center; box-shadow: none; }
    .ib-shell[data-page="analytics"] .ib-nav-btn, .ib-shell[data-page="customer-report"] .ib-nav-btn { flex: 0 0 42px; width: 42px; justify-content: center; }
    .ib-shell[data-page="analytics"] .ib-nav-label, .ib-shell[data-page="customer-report"] .ib-nav-label { display: none; }
    .ib-shell[data-page="analytics"] .ib-nav-logo, .ib-shell[data-page="customer-report"] .ib-nav-logo,
    .ib-shell[data-page="analytics"] .ib-nav-spacer, .ib-shell[data-page="customer-report"] .ib-nav-spacer,
    .ib-shell[data-page="analytics"] .ib-nav-user, .ib-shell[data-page="customer-report"] .ib-nav-user { display: none; }
    .ib-shell[data-page="analytics"] .ib-analytics, .ib-shell[data-page="customer-report"] .ib-report { grid-row: 1; }
    .ib-shell[data-view="chat"] .ib-list { display: none; }
    .ib-shell[data-view="list"] .ib-chat { display: none; }
    .ib-back { display: inline-flex; }
    .ib-list { border-right: 0; }
    .ib-item { padding: 14px 16px; }
    .ib-messages { padding: 18px 14px !important; }
    .ib-bubble { max-width: 88% !important; }
    .ib-chat-header { gap: 8px !important; padding: 10px 12px !important; }
    .ib-chat-header [aria-label="Siapa yang menjawab"] { margin-left: auto; }
    .ib-composer { padding: 10px 12px max(12px, env(safe-area-inset-bottom)) !important; }
    .ib-analytics { padding: 18px 14px; }
    .ib-report { padding: 18px 14px; }
    .ib-report-header { align-items: flex-start; flex-direction: column; gap: 12px; }
    .ib-report-title { font-size: 24px; }
    .ib-report-filter { align-items: stretch; }
    .ib-report-filter label { flex: 1 1 130px; }
    .ib-report-control, .ib-report-export { width: 100%; }
    .ib-report-table th, .ib-report-table td { padding: 10px; }
    .ib-report-table td:last-child { min-width: 220px; }
    .ib-analytics-header { align-items: flex-start; flex-direction: column; gap: 10px; }
    .ib-analytics-title { font-size: 24px; }
    .ib-analytics-tabs { gap: 0; margin-left: -8px; }
    .ib-analytics-tab { padding: 8px; font-size: 13px; }
    .ib-analytics-grid { display: flex; flex-direction: column; gap: 12px; }
    .ib-analytics-card { min-height: 250px; padding: 16px; }
    .ib-analytics-card.third { min-height: 200px; }
    .ib-analytics-filter { padding: 14px 0 16px; }
    .ib-analytics-control { flex: 1 1 130px; min-width: 0; }
    .ib-chart { height: 170px; }
  }
`;

const AVATAR_COLORS = ["#31304D", "#4C6B5A", "#8A5A44", "#5B5F8F", "#7A6A3A", "#3F6F7A"];
const FILTERS = [
  { key: "all", label: "Semua", count: "total" },
  { key: "unread", label: "Belum dibaca", count: "unread" },
  { key: "human", label: "Agen", count: "human" },
];

function avatarColor(seed) {
  let h = 0;
  for (const ch of String(seed)) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return AVATAR_COLORS[h % AVATAR_COLORS.length];
}
const initialOf = (name) => ((name || "?").trim()[0] || "?").toUpperCase();
const formatPhone = (phone) => (phone ? "+" + phone : "");
const inputDate = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

function TrendChart({ data, firstKey, secondKey, firstLabel, secondLabel }) {
  const width = 720;
  const height = 190;
  const left = 38;
  const right = 12;
  const top = 14;
  const bottom = 34;
  const chartWidth = width - left - right;
  const chartHeight = height - top - bottom;
  const values = data.flatMap((row) => [row[firstKey], ...(secondKey ? [row[secondKey]] : [])]);
  const max = Math.max(1, ...values);
  const pointsFor = (key) =>
    data.map((row, index) => ({
      x: left + (data.length < 2 ? chartWidth / 2 : (index / (data.length - 1)) * chartWidth),
      y: top + chartHeight - (row[key] / max) * chartHeight,
      value: row[key],
    }));
  const lineFor = (points) => points.map((point, index) => `${index ? "L" : "M"}${point.x},${point.y}`).join(" ");
  const firstPoints = pointsFor(firstKey);
  const secondPoints = secondKey ? pointsFor(secondKey) : [];
  const labelStep = Math.max(1, Math.ceil(data.length / 7));

  if (!data.length) return <div className="ib-analytics-empty">Tidak ada data pada rentang tanggal ini.</div>;

  return (
    <>
      <svg className="ib-chart" viewBox={`0 0 ${width} ${height}`} role="img" aria-label="Grafik tren berdasarkan tanggal">
        {[0, 0.5, 1].map((fraction) => {
          const y = top + chartHeight * fraction;
          return (
            <g key={fraction}>
              <line className="ib-chart-grid" x1={left} x2={width - right} y1={y} y2={y} />
              <text className="ib-chart-label" x={left - 8} y={y + 4} textAnchor="end">
                {Math.round(max * (1 - fraction))}
              </text>
            </g>
          );
        })}
        <path className="ib-chart-line" d={lineFor(firstPoints)} />
        {firstPoints.map((point, index) => (
          <circle key={`first-${index}`} className="ib-chart-dot" cx={point.x} cy={point.y} r="4">
            <title>{`${data[index].date}: ${firstLabel} ${point.value}`}</title>
          </circle>
        ))}
        {secondKey && (
          <>
            <path className="ib-chart-line secondary" d={lineFor(secondPoints)} />
            {secondPoints.map((point, index) => (
              <circle key={`second-${index}`} className="ib-chart-dot secondary" cx={point.x} cy={point.y} r="4">
                <title>{`${data[index].date}: ${secondLabel} ${point.value}`}</title>
              </circle>
            ))}
          </>
        )}
        {data.map((row, index) =>
          index % labelStep === 0 || index === data.length - 1 ? (
            <text key={row.date} className="ib-chart-label" x={firstPoints[index].x} y={height - 8} textAnchor="middle">
              {new Date(`${row.date}T00:00:00`).toLocaleDateString("id-ID", { day: "numeric", month: "short" })}
            </text>
          ) : null
        )}
      </svg>
      <div className="ib-chart-legend">
        <span><i />{firstLabel}</span>
        {secondKey && <span><i className="secondary" />{secondLabel}</span>}
      </div>
    </>
  );
}

function AnalyticsCard({ title, total, unit, className = "", children }) {
  return (
    <section className={`ib-analytics-card ${className}`}>
      <h2 className="ib-analytics-card-title">{title}</h2>
      {total !== undefined && (
        <div className="ib-analytics-total">
          {(typeof total === "number" ? total.toLocaleString("id-ID") : total)}<span>{unit}</span>
        </div>
      )}
      {children}
    </section>
  );
}

function AnalyticsDashboard({ tab, setTab, from, setFrom, to, setTo, channel, setChannel, data, loading, error }) {
  const firstTotal = data?.sessions.reduce((sum, item) => sum + item.first, 0) || 0;
  const returningTotal = data?.sessions.reduce((sum, item) => sum + item.returning, 0) || 0;
  const aiTotal = data?.replies.reduce((sum, item) => sum + item.ai, 0) || 0;
  const humanTotal = data?.replies.reduce((sum, item) => sum + item.human, 0) || 0;
  const selectedReplies = tab === "AI Agent" ? aiTotal : humanTotal;
  const channels = data?.sources || [];
  const maxSource = Math.max(1, ...channels.map((item) => item.total));

  return (
    <main className="ib-analytics">
      <header className="ib-analytics-header">
        <h1 className="ib-analytics-title">Analytics</h1>
        <div className="ib-analytics-tabs" role="tablist" aria-label="Jenis analitik">
          {["Session", "AI Agent", "Human Agent"].map((item) => (
            <button
              key={item}
              type="button"
              role="tab"
              aria-selected={tab === item}
              aria-pressed={tab === item}
              className="ib-analytics-tab"
              onClick={() => setTab(item)}
            >
              {item}
            </button>
          ))}
        </div>
      </header>

      <div className="ib-analytics-filter">
        <select className="ib-analytics-control" aria-label="Pilih kanal inbox" value={channel} onChange={(event) => setChannel(event.target.value)}>
          <option value="all">Semua inbox</option>
          <option value="whatsapp">WhatsApp</option>
          <option value="web">Web Chat</option>
        </select>
        <label>
          <span className="ib-sr">Dari tanggal</span>
          <input className="ib-analytics-control" type="date" value={from} max={to} onChange={(event) => setFrom(event.target.value)} />
        </label>
        <span aria-hidden="true">–</span>
        <label>
          <span className="ib-sr">Sampai tanggal</span>
          <input className="ib-analytics-control" type="date" value={to} min={from} onChange={(event) => setTo(event.target.value)} />
        </label>
      </div>

      {error && <div className="ib-analytics-error" role="alert">{error}</div>}
      {loading && <div className="ib-analytics-empty" role="status">Memuat analitik…</div>}
      {!loading && data && tab === "Session" && (
        <div className="ib-analytics-grid">
          <AnalyticsCard title="First Customer Session" total={firstTotal} unit="Sesi baru">
            <TrendChart data={data.sessions} firstKey="first" firstLabel="Sesi baru" />
          </AnalyticsCard>
          <AnalyticsCard title="Returning Customer Session" total={returningTotal} unit="Sesi kembali">
            <TrendChart data={data.sessions} firstKey="returning" firstLabel="Sesi kembali" />
          </AnalyticsCard>
          <AnalyticsCard title="Session Source" total={firstTotal + returningTotal} unit="Sesi" className="third">
            {channels.length ? (
              <div className="ib-analytics-bars">
                {channels.map((item) => (
                  <div className="ib-analytics-bar-row" key={item.channel}>
                    <span>{item.channel === "whatsapp" ? "WhatsApp" : item.channel === "web" ? "Web Chat" : item.channel}</span>
                    <div className="ib-analytics-bar-track"><div className="ib-analytics-bar" style={{ width: `${(item.total / maxSource) * 100}%` }} /></div>
                    <strong>{item.total.toLocaleString("id-ID")}</strong>
                  </div>
                ))}
              </div>
            ) : <div className="ib-analytics-empty">Belum ada sesi pada periode ini.</div>}
          </AnalyticsCard>
          <AnalyticsCard title="Session Resolution Rate" total="—" unit="">
            <div className="ib-analytics-empty">Tanggal perubahan status selesai belum dicatat, jadi tingkat resolusi per periode belum tersedia.</div>
          </AnalyticsCard>
          <AnalyticsCard title="Session Label" total="—" unit="" className="third">
            <div className="ib-analytics-empty">Data label belum tersedia karena fitur label belum diterapkan.</div>
          </AnalyticsCard>
        </div>
      )}
      {!loading && data && tab !== "Session" && (
        <div className="ib-analytics-grid">
          <AnalyticsCard title={`${tab} Replies`} total={selectedReplies} unit="Balasan">
            <TrendChart
              data={data.replies}
              firstKey={tab === "AI Agent" ? "ai" : "human"}
              firstLabel={tab === "AI Agent" ? "Balasan AI" : "Balasan agen"}
            />
          </AnalyticsCard>
          <AnalyticsCard title="Perbandingan Balasan" total={aiTotal + humanTotal} unit="Balasan">
            <div className="ib-analytics-bars">
              {[
                { label: "AI Agent", total: aiTotal },
                { label: "Human Agent", total: humanTotal },
              ].map((item) => (
                <div className="ib-analytics-bar-row" key={item.label}>
                  <span>{item.label}</span>
                  <div className="ib-analytics-bar-track"><div className="ib-analytics-bar" style={{ width: `${(item.total / Math.max(1, aiTotal, humanTotal)) * 100}%` }} /></div>
                  <strong>{item.total.toLocaleString("id-ID")}</strong>
                </div>
              ))}
            </div>
          </AnalyticsCard>
        </div>
      )}
    </main>
  );
}

function csvCell(value) {
  const text = String(value ?? "");
  const safeText = /^[\s]*[=+\-@]/.test(text) ? `'${text}` : text;
  return `"${safeText.replace(/"/g, '""')}"`;
}

function exportCustomerReport(rows) {
  const headers = ["Nama", "Asal", "Timestamp terakhir chat customer", "No. WA", "Summary kebutuhan kemasan"];
  const lines = [
    headers,
    ...rows.map((row) => [
      row.name,
      row.origin,
      row.lastCustomerMessageAt,
      row.phone,
      row.summary,
    ]),
  ].map((line) => line.map(csvCell).join(","));
  const blob = new Blob(["\uFEFF", lines.join("\r\n")], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `laporan-chat-customer-${inputDate(new Date())}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 0);
}

function CustomerChatReport({ from, setFrom, to, setTo, data, loading, error }) {
  const rows = data?.conversations || [];
  return (
    <main className="ib-report">
      <header className="ib-report-header">
        <div>
          <h1 className="ib-report-title">Laporan Chat Customer</h1>
          <p className="ib-report-subtitle">Ringkasan kebutuhan pembuatan kemasan dari riwayat chat WhatsApp.</p>
        </div>
        <button
          type="button"
          className="ib-report-export"
          disabled={loading || rows.length === 0}
          onClick={() => exportCustomerReport(rows)}
        >
          Export CSV
        </button>
      </header>

      <div className="ib-report-filter">
        <label>
          Dari tanggal
          <input className="ib-report-control" type="date" value={from} max={to} onChange={(event) => setFrom(event.target.value)} />
        </label>
        <label>
          Sampai tanggal
          <input className="ib-report-control" type="date" value={to} min={from} onChange={(event) => setTo(event.target.value)} />
        </label>
      </div>

      {error && <div className="ib-report-error" role="alert">{error}</div>}
      {loading && <div className="ib-report-empty" role="status">Memuat laporan chat customer…</div>}
      {!loading && !error && data && (
        <>
          <p className="ib-report-count">{rows.length.toLocaleString("id-ID")} customer</p>
          <div className="ib-report-table-wrap">
            {rows.length ? (
              <table className="ib-report-table">
                <thead>
                  <tr>
                    <th>Nama</th>
                    <th>Asal</th>
                    <th>Chat customer terakhir</th>
                    <th>No. WA</th>
                    <th>Summary kebutuhan kemasan</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row) => (
                    <tr key={row.id}>
                      <td>{row.name || "—"}</td>
                      <td>{row.origin}</td>
                      <td>{new Date(row.lastCustomerMessageAt).toLocaleString("id-ID")}</td>
                      <td>{row.phone || "—"}</td>
                      <td>{row.summary}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="ib-report-empty">Tidak ada chat customer pada rentang tanggal ini.</div>
            )}
          </div>
        </>
      )}
    </main>
  );
}

function sameDay(a, b) {
  return (
    a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate()
  );
}
function yesterdayOf(now) {
  const y = new Date(now);
  y.setDate(now.getDate() - 1);
  return y;
}
function clockLabel(iso) {
  return new Date(iso).toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" });
}
function listTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const now = new Date();
  if (sameDay(d, now)) return clockLabel(iso);
  if (sameDay(d, yesterdayOf(now))) return "Kemarin";
  return d.toLocaleDateString("id-ID", { day: "2-digit", month: "2-digit", year: "2-digit" });
}
function formatFileSize(bytes) {
  if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
function dayLabel(iso) {
  const d = new Date(iso);
  const now = new Date();
  if (sameDay(d, now)) return "Hari ini";
  if (sameDay(d, yesterdayOf(now))) return "Kemarin";
  return d.toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" });
}
function previewOf(conv) {
  const m = conv.lastMessage;
  if (!m) return "Belum ada pesan";
  const prefix = m.from === "agent" ? "Agen: " : m.from === "ai" ? "AI: " : "";
  const attachmentPreview = m.attachmentName
    ? `📎 ${m.attachmentName}`
    : m.attachmentMimeType
      ? m.attachmentMimeType.startsWith("image/") ? "📷 Foto" : "📎 Lampiran"
      : "";
  const content = m.content ? m.content.replace(/\s+/g, " ") : attachmentPreview;
  return prefix + content;
}

// Chip status siapa yang menjawab; hitung mundur berjalan di komponen ini saja
// supaya tidak me-render ulang seluruh inbox tiap detik.
function StatusChip({ aiEnabled, aiState, receivedAt }) {
  const [, tick] = useState(0);
  const waiting = aiEnabled && aiState && aiState.status === "waiting";
  useEffect(() => {
    if (!waiting) return undefined;
    const id = setInterval(() => tick((n) => n + 1), 1000);
    return () => clearInterval(id);
  }, [waiting]);

  let text;
  let tone;
  let announce;
  if (!aiEnabled) {
    text = "Mode Agen";
    tone = S.chipAgent;
    announce = "Mode agen: AI tidak menjawab otomatis";
  } else if (aiState && aiState.status === "thinking") {
    text = "AI sedang menyusun jawaban…";
    tone = S.chipBusy;
    announce = "AI sedang menyusun jawaban";
  } else if (waiting) {
    const left = Math.max(0, aiState.secondsLeft - Math.floor((Date.now() - receivedAt) / 1000));
    text = left > 0 ? `AI menjawab dalam ${left} dtk` : "AI sedang menyusun jawaban…";
    tone = S.chipBusy;
    announce = "AI akan segera menjawab";
  } else {
    text = "AI aktif";
    tone = S.chipAi;
    announce = "AI aktif";
  }

  return (
    <span style={{ ...S.chip, ...tone }}>
      {tone === S.chipBusy && <span className="ib-pulse" style={S.chipDot} aria-hidden="true" />}
      <span aria-hidden="true">{text}</span>
      <span className="ib-sr" role="status">
        {announce}
      </span>
    </span>
  );
}

const Bubble = React.memo(function Bubble({ m }) {
  const fromCustomer = m.from === "customer";
  const label = m.from === "ai" ? "AI" : m.from === "agent" ? m.senderName || "Agen" : null;
  const tone = fromCustomer ? S.bubbleCustomer : m.from === "ai" ? S.bubbleAi : S.bubbleAgent;
  return (
    <div className="ib-message-row" style={{ display: "flex", justifyContent: fromCustomer ? "flex-start" : "flex-end" }}>
      <div className="ib-bubble" style={{ ...S.bubble, ...tone, opacity: m.pending ? 0.6 : 1 }}>
        {label && <div style={S.bubbleLabel}>{label}</div>}
        {(m.attachments || []).map((attachment) => (
          <div className="ib-bubble-attachment" key={attachment.id || attachment.fileId || attachment.filename}>
            {attachment.mimeType && attachment.mimeType.startsWith("image/") && attachment.url ? (
              <a href={attachment.url} target="_blank" rel="noreferrer" aria-label={`Buka gambar ${attachment.filename}`}>
                <img className="ib-bubble-image" src={attachment.url} alt={attachment.filename} />
              </a>
            ) : attachment.url ? (
              <a className="ib-bubble-file" href={attachment.url} download={attachment.filename}>
                📎 {attachment.filename}
              </a>
            ) : (
              <span className="ib-bubble-file">📎 {attachment.filename}</span>
            )}
          </div>
        ))}
        {m.content && <div style={S.bubbleText}>{m.content}</div>}
        <div style={S.bubbleTime}>{m.pending ? "Mengirim…" : clockLabel(m.createdAt)}</div>
      </div>
    </div>
  );
});

function Avatar({ name, phone, size = 42 }) {
  return (
    <span style={{ ...S.avatarWrap, width: size, height: size }}>
      <span
        style={{
          ...S.avatar,
          width: size,
          height: size,
          fontSize: size * 0.42,
          background: avatarColor(name + phone),
        }}
        aria-hidden="true"
      >
        {initialOf(name)}
      </span>
      <span style={S.channelDot} title="WhatsApp" aria-hidden="true">
        WA
      </span>
    </span>
  );
}

export default function OmnichannelInbox({ session, onSwitchToChat, onLogout }) {
  const token = session.token;

  const [page, setPage] = useState("inbox");
  const [analyticsTab, setAnalyticsTab] = useState("Session");
  const [analyticsChannel, setAnalyticsChannel] = useState("all");
  const [analyticsFrom, setAnalyticsFrom] = useState(() => {
    const date = new Date();
    date.setDate(date.getDate() - 6);
    return inputDate(date);
  });
  const [analyticsTo, setAnalyticsTo] = useState(() => inputDate(new Date()));
  const [analyticsData, setAnalyticsData] = useState(null);
  const [analyticsLoading, setAnalyticsLoading] = useState(false);
  const [analyticsError, setAnalyticsError] = useState(null);
  const [reportFrom, setReportFrom] = useState(() => {
    const date = new Date();
    date.setDate(date.getDate() - 6);
    return inputDate(date);
  });
  const [reportTo, setReportTo] = useState(() => inputDate(new Date()));
  const [reportData, setReportData] = useState(null);
  const [reportLoading, setReportLoading] = useState(false);
  const [reportError, setReportError] = useState(null);

  const [conversations, setConversations] = useState([]);
  const [summary, setSummary] = useState({ total: 0, unread: 0, human: 0 });
  const [filter, setFilter] = useState("all");
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");
  const [listLoaded, setListLoaded] = useState(false);
  const [listError, setListError] = useState(null);
  const [forbidden, setForbidden] = useState(false);

  const [activeId, setActiveId] = useState(null);
  const [mobileView, setMobileView] = useState("list");
  const [detail, setDetail] = useState(null); // { conversation, messages, aiState }
  const [detailAt, setDetailAt] = useState(0);
  const [chatLoading, setChatLoading] = useState(false);
  const [loadError, setLoadError] = useState(null);
  const [chatOffline, setChatOffline] = useState(false);
  const [actionError, setActionError] = useState(null);
  const [profileError, setProfileError] = useState(null);
  const [noteDrafts, setNoteDrafts] = useState({});
  const [savingNotes, setSavingNotes] = useState(false);
  const [savingStatus, setSavingStatus] = useState(false);

  const [input, setInput] = useState("");
  const [sending, setSending] = useState(false);
  const [emojiPickerOpen, setEmojiPickerOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadedAttachment, setUploadedAttachment] = useState(null);
  const [pendingOut, setPendingOut] = useState([]); // balasan yang sedang dikirim (optimistis)
  const [togglingMode, setTogglingMode] = useState(false);
  const [visible, setVisible] = useState(() => !document.hidden);

  const activeIdRef = useRef(null);
  const listReqRef = useRef(0);
  const mutationRef = useRef(0); // naik tiap perubahan lokal -> hasil polling yang lebih lama dibuang
  const scrollRef = useRef(null);
  const stickRef = useRef(true);
  const lastReadRef = useRef(null);
  const textareaRef = useRef(null);
  const fileInputRef = useRef(null);

  // ---------- daftar percakapan ----------
  useEffect(() => {
    const t = setTimeout(() => setSearch(searchInput.trim()), 300);
    return () => clearTimeout(t);
  }, [searchInput]);

  const loadList = useCallback(async () => {
    const reqId = ++listReqRef.current;
    try {
      const params = new URLSearchParams({ filter });
      if (search) params.set("search", search);
      const data = await apiRequest(`/inbox/conversations?${params}`, { token });
      if (reqId !== listReqRef.current) return; // jawaban lama (filter/pencarian sudah berubah)
      setConversations(data.conversations);
      setSummary(data.summary);
      setListError(null);
      setForbidden(false);
    } catch (err) {
      if (reqId !== listReqRef.current) return;
      if (err.status === 403) setForbidden(true);
      else setListError(err.message);
    } finally {
      if (reqId === listReqRef.current) setListLoaded(true);
    }
  }, [token, filter, search]);

  const loadListRef = useRef(loadList);
  loadListRef.current = loadList;

  useEffect(() => {
    loadList();
    const timer = setInterval(() => {
      if (!document.hidden) loadList();
    }, inboxConfig.listPollMs);
    return () => clearInterval(timer);
  }, [loadList]);

  useEffect(() => {
    if (page !== "analytics") return undefined;
    let cancelled = false;
    setAnalyticsLoading(true);
    setAnalyticsError(null);
    const params = new URLSearchParams({
      from: analyticsFrom,
      to: analyticsTo,
      channel: analyticsChannel,
    });
    apiRequest(`/inbox/analytics?${params}`, { token })
      .then((data) => {
        if (!cancelled) setAnalyticsData(data);
      })
      .catch((err) => {
        if (!cancelled) setAnalyticsError(err.message);
      })
      .finally(() => {
        if (!cancelled) setAnalyticsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [page, token, analyticsFrom, analyticsTo, analyticsChannel]);

  useEffect(() => {
    if (page !== "customer-report") return undefined;
    let cancelled = false;
    setReportLoading(true);
    setReportError(null);
    setReportData(null);
    const params = new URLSearchParams({ from: reportFrom, to: reportTo });
    apiRequest(`/inbox/customer-chat-report?${params}`, { token })
      .then((data) => {
        if (!cancelled) setReportData(data);
      })
      .catch((err) => {
        if (!cancelled) setReportError(err.message);
      })
      .finally(() => {
        if (!cancelled) setReportLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [page, token, reportFrom, reportTo]);

  useEffect(() => {
    function onVisibility() {
      setVisible(!document.hidden);
    }
    document.addEventListener("visibilitychange", onVisibility);
    return () => document.removeEventListener("visibilitychange", onVisibility);
  }, []);

  // Judul tab menampilkan jumlah percakapan belum dibaca
  useEffect(() => {
    const previous = document.title;
    document.title = (summary.unread > 0 ? `(${summary.unread}) ` : "") + "Inbox WhatsApp";
    return () => {
      document.title = previous;
    };
  }, [summary.unread]);

  // ---------- percakapan yang dibuka ----------
  const loadChat = useCallback(
    async (id, { initial = false } = {}) => {
      const version = mutationRef.current;
      if (initial) setChatLoading(true);
      try {
        const data = await apiRequest(`/inbox/conversations/${id}`, { token });
        if (activeIdRef.current !== id) return;
        setChatOffline(false);
        setLoadError(null);
        if (version !== mutationRef.current) return; // ada perubahan lokal selagi menunggu: hasil ini basi
        setDetail(data);
        setDetailAt(Date.now());
      } catch (err) {
        if (activeIdRef.current !== id) return;
        if (err.status === 404) {
          setActiveId(null);
          setMobileView("list");
          loadListRef.current();
        } else if (initial) setLoadError(err.message);
        else setChatOffline(true);
      } finally {
        if (initial && activeIdRef.current === id) setChatLoading(false);
      }
    },
    [token]
  );

  useEffect(() => {
    activeIdRef.current = activeId;
    setDetail(null);
    setLoadError(null);
    setChatOffline(false);
    setActionError(null);
    setProfileError(null);
    stickRef.current = true;
    lastReadRef.current = null;
    if (!activeId) return undefined;
    loadChat(activeId, { initial: true });
    const timer = setInterval(() => {
      if (!document.hidden) loadChat(activeId);
    }, inboxConfig.chatPollMs);
    return () => clearInterval(timer);
  }, [activeId, loadChat]);

  // Kembali ke tab ini: segarkan langsung
  const wasVisibleRef = useRef(true);
  useEffect(() => {
    if (visible && !wasVisibleRef.current) {
      loadListRef.current();
      if (activeIdRef.current) loadChat(activeIdRef.current);
    }
    wasVisibleRef.current = visible;
  }, [visible, loadChat]);

  // Tandai dibaca sampai pesan pelanggan terakhir yang sedang tampil
  useEffect(() => {
    if (!detail || !activeId || detail.conversation.id !== activeId || !visible) return;
    const lastCustomer = [...detail.messages].reverse().find((m) => m.from === "customer");
    if (!lastCustomer || lastReadRef.current === lastCustomer.id) return;
    lastReadRef.current = lastCustomer.id;
    apiRequest(`/inbox/conversations/${activeId}/read`, {
      method: "POST",
      token,
      body: { upToMessageId: lastCustomer.id },
    })
      .then(() => {
        setConversations((prev) => prev.map((c) => (c.id === activeId ? { ...c, unread: 0 } : c)));
        loadList();
      })
      .catch(() => {
        lastReadRef.current = null; // coba lagi pada polling berikutnya
      });
  }, [detail, activeId, token, visible, loadList]);

  // Gulir otomatis ke pesan terbaru, kecuali agen sedang membaca pesan lama
  useEffect(() => {
    const el = scrollRef.current;
    if (el && stickRef.current) el.scrollTop = el.scrollHeight;
  }, [detail, pendingOut, activeId]);

  useEffect(() => {
    const el = textareaRef.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = Math.min(el.scrollHeight, 140) + "px";
  }, [input]);

  function handleScroll(e) {
    const el = e.currentTarget;
    stickRef.current = el.scrollHeight - el.scrollTop - el.clientHeight < 120;
  }

  function openConversation(id) {
    setActiveId(id);
    setMobileView("chat");
    setEmojiPickerOpen(false);
    setSelectedFile(null);
    setUploadedAttachment(null);
  }

  function chooseAttachment(event) {
    const file = event.target.files && event.target.files[0];
    event.target.value = "";
    if (!file) return;
    if (file.size > MAX_ATTACHMENT_BYTES) {
      setActionError("Ukuran file maksimal 16 MB.");
      return;
    }
    setActionError(null);
    setSelectedFile(file);
    setUploadedAttachment(null);
  }

  function insertEmoji(emoji) {
    const textarea = textareaRef.current;
    if (!textarea) return;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const nextInput = input.slice(0, start) + emoji + input.slice(end);
    setInput(nextInput);
    setEmojiPickerOpen(false);
    const focusAndPosition = () => {
      textarea.focus();
      const cursor = start + emoji.length;
      textarea.setSelectionRange(cursor, cursor);
    };
    if (typeof window.requestAnimationFrame === "function") window.requestAnimationFrame(focusAndPosition);
    else setTimeout(focusAndPosition, 0);
  }

  // ---------- aksi agen ----------
  async function sendMessage() {
    const text = input.trim();
    const file = selectedFile;
    if ((!text && !file) || sending || !activeId || !detail) return;
    const id = activeId;
    const tempId = "tmp-" + Date.now();

    setSending(true);
    setActionError(null);
    mutationRef.current++;
    stickRef.current = true;
    setPendingOut((p) => [
      ...p,
      {
        tempId,
        conversationId: id,
        content: text,
        attachments: file ? [{ filename: file.name, mimeType: file.type }] : [],
        at: Date.now(),
      },
    ]);
    setInput("");

    try {
      let attachment = uploadedAttachment;
      if (file && !attachment) {
        const params = new URLSearchParams({ filename: file.name });
        const upload = await apiRequest(`/inbox/conversations/${id}/attachments?${params}`, {
          method: "POST",
          token,
          body: file,
          isRawBody: true,
          contentType: file.type || "application/octet-stream",
        });
        attachment = upload.attachment;
        setUploadedAttachment(attachment);
      }

      const data = await apiRequest(`/inbox/conversations/${id}/messages`, {
        method: "POST",
        token,
        body: {
          content: text,
          ...(attachment ? { attachment: { fileId: attachment.fileId, filename: attachment.filename } } : {}),
        },
      });
      mutationRef.current++;
      setDetail((d) =>
        d && d.conversation.id === id
          ? {
              ...d,
              conversation: { ...d.conversation, aiEnabled: false },
              messages: d.messages.some((m) => m.id === data.message.id)
                ? d.messages
                : [...d.messages, data.message],
              aiState: { status: "idle", secondsLeft: 0 },
            }
          : d
      );
      setDetailAt(Date.now());
      setSelectedFile(null);
      setUploadedAttachment(null);
      if (fileInputRef.current) fileInputRef.current.value = "";
      loadList();
    } catch (err) {
      setActionError(err.message);
      setInput((current) => (current ? current : text)); // kembalikan teks agar tidak hilang
    } finally {
      setPendingOut((p) => p.filter((x) => x.tempId !== tempId));
      setSending(false);
    }
  }

  async function changeMode(aiEnabled) {
    if (!detail || togglingMode || detail.conversation.aiEnabled === aiEnabled) return;
    const id = activeId;
    setTogglingMode(true);
    setActionError(null);
    mutationRef.current++;
    try {
      await apiRequest(`/inbox/conversations/${id}`, { method: "PATCH", token, body: { aiEnabled } });
      mutationRef.current++;
      await loadChat(id); // ambil status & hitung mundur terbaru
      loadList();
    } catch (err) {
      setActionError(err.message);
    } finally {
      setTogglingMode(false);
    }
  }

  async function changeChatStatus(status) {
    if (!detail || savingStatus || detail.conversation.status === status) return;
    const id = activeId;
    setSavingStatus(true);
    setProfileError(null);
    mutationRef.current++;
    try {
      const data = await apiRequest(`/inbox/conversations/${id}`, {
        method: "PATCH",
        token,
        body: { status },
      });
      mutationRef.current++;
      setDetail((current) =>
        current && current.conversation.id === id
          ? { ...current, conversation: { ...current.conversation, status: data.status } }
          : current
      );
      setConversations((current) =>
        current.map((conversation) =>
          conversation.id === id ? { ...conversation, status: data.status } : conversation
        )
      );
    } catch (err) {
      setProfileError(err.message);
    } finally {
      setSavingStatus(false);
    }
  }

  async function saveAdditionalNotes() {
    if (!detail || savingNotes) return;
    const id = activeId;
    const additionalNotes = noteDrafts[id] ?? detail.conversation.additionalNotes ?? "";
    if (additionalNotes === (detail.conversation.additionalNotes || "")) return;
    setSavingNotes(true);
    setProfileError(null);
    mutationRef.current++;
    try {
      const data = await apiRequest(`/inbox/conversations/${id}`, {
        method: "PATCH",
        token,
        body: { additionalNotes },
      });
      mutationRef.current++;
      setDetail((current) =>
        current && current.conversation.id === id
          ? { ...current, conversation: { ...current.conversation, additionalNotes: data.additionalNotes } }
          : current
      );
      setNoteDrafts((current) => ({ ...current, [id]: data.additionalNotes }));
    } catch (err) {
      setProfileError(err.message);
    } finally {
      setSavingNotes(false);
    }
  }

  function handleKeyDown(e) {
    if (e.key === "Enter" && !e.shiftKey && !e.nativeEvent.isComposing) {
      e.preventDefault();
      sendMessage();
    }
  }

  // ---------- tampilan ----------
  const rows = useMemo(() => {
    if (!detail) return [];
    const mine = pendingOut
      .filter((p) => p.conversationId === detail.conversation.id)
      .map((p) => ({
        id: p.tempId,
        from: "agent",
        senderName: session.user.username,
        content: p.content,
        attachments: p.attachments,
        createdAt: new Date(p.at).toISOString(),
        pending: true,
      }));
    const out = [];
    let lastDay = null;
    for (const m of [...detail.messages, ...mine]) {
      const day = new Date(m.createdAt).toDateString();
      if (day !== lastDay) {
        out.push({ type: "day", key: "day-" + day, label: dayLabel(m.createdAt) });
        lastDay = day;
      }
      out.push({ type: "msg", key: m.id, m });
    }
    return out;
  }, [detail, pendingOut, session.user.username]);

  if (forbidden) {
    return (
      <div style={S.forbidden} role="alert">
        <div style={S.emptyTitle}>Akun Anda belum memiliki akses Inbox</div>
        <div style={S.emptyText}>Minta administrator menjadikan akun Anda sebagai agen.</div>
        <button className="ib-focusable" style={S.primaryBtn} onClick={onSwitchToChat}>
          Kembali ke Chat AI
        </button>
        <style>{INBOX_STYLES}</style>
      </div>
    );
  }

  const aiEnabled = detail ? detail.conversation.aiEnabled : true;

  return (
    <div className="ib-shell" data-view={mobileView} data-page={page}>
      <style>{INBOX_STYLES}</style>

      <aside className="ib-nav" aria-label="Navigasi utama">
        <div className="ib-nav-logo" aria-label="Omnichannel">
          <span className="ib-nav-icon">WA</span>
          <span className="ib-nav-label">Omnichannel</span>
        </div>
        <button className="ib-nav-btn" aria-label="Inbox WhatsApp" aria-current={page === "inbox" ? "page" : undefined} title="Inbox WhatsApp" onClick={() => setPage("inbox")}>
          <span className="ib-nav-icon" aria-hidden="true">▦</span>
          <span className="ib-nav-label">Inbox WhatsApp</span>
        </button>
        <button className="ib-nav-btn" aria-label="Chat AI" title="Chat AI" onClick={onSwitchToChat}>
          <span className="ib-nav-icon" aria-hidden="true">◷</span>
          <span className="ib-nav-label">Chat AI</span>
        </button>
        <button className="ib-nav-btn" aria-label="Analytics" aria-current={page === "analytics" ? "page" : undefined} title="Analytics" onClick={() => setPage("analytics")}>
          <span className="ib-nav-icon" aria-hidden="true">▥</span>
          <span className="ib-nav-label">Analytics</span>
        </button>
        <button className="ib-nav-btn" aria-label="Laporan Chat Customer" aria-current={page === "customer-report" ? "page" : undefined} title="Laporan Chat Customer" onClick={() => setPage("customer-report")}>
          <span className="ib-nav-icon" aria-hidden="true">▤</span>
          <span className="ib-nav-label">Laporan Chat Customer</span>
        </button>
        <div className="ib-nav-spacer" />
        <span className="ib-nav-user" title={session.user.username}>
          {initialOf(session.user.username)}
        </span>
        <button className="ib-nav-btn" aria-label="Keluar" title="Keluar" onClick={onLogout}>
          <span className="ib-nav-icon" aria-hidden="true">↪</span>
          <span className="ib-nav-label">Keluar</span>
        </button>
      </aside>

      {page === "analytics" ? (
        <AnalyticsDashboard
          tab={analyticsTab}
          setTab={setAnalyticsTab}
          from={analyticsFrom}
          setFrom={setAnalyticsFrom}
          to={analyticsTo}
          setTo={setAnalyticsTo}
          channel={analyticsChannel}
          setChannel={setAnalyticsChannel}
          data={analyticsData}
          loading={analyticsLoading}
          error={analyticsError}
        />
      ) : page === "customer-report" ? (
        <CustomerChatReport
          from={reportFrom}
          setFrom={setReportFrom}
          to={reportTo}
          setTo={setReportTo}
          data={reportData}
          loading={reportLoading}
          error={reportError}
        />
      ) : (
        <>
      {/* ===== Daftar percakapan ===== */}
      <div className="ib-list">
        <div style={S.listHeader}>
          <div style={S.brandRow}>
            <span style={S.brandMark} aria-hidden="true">WA</span>
            <span>OMNICHANNEL</span>
          </div>

          <div style={S.titleRow}>
            <h1 style={S.title}>Inbox WhatsApp</h1>
            {summary.unread > 0 && (
              <span style={S.totalBadge} aria-label={`${summary.unread} percakapan belum dibaca`}>
                {summary.unread}
              </span>
            )}
          </div>

          <input
            className="ib-focusable"
            type="search"
            aria-label="Cari nama atau nomor"
            placeholder="Cari nama atau nomor…"
            style={S.search}
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
          />

          <div role="group" aria-label="Filter percakapan" style={S.filters}>
            {FILTERS.map((f) => (
              <button
                key={f.key}
                className="ib-focusable"
                aria-pressed={filter === f.key}
                style={{ ...S.filterBtn, ...(filter === f.key ? S.filterBtnOn : null) }}
                onClick={() => setFilter(f.key)}
              >
                {f.label} <span style={S.filterCount}>{summary[f.count]}</span>
              </button>
            ))}
          </div>
        </div>

        {listError && (
          <div style={S.listError} role="alert">
            {listError} — mencoba lagi otomatis.
          </div>
        )}

        <nav aria-label="Daftar percakapan" className="ib-scroll" style={S.listBody}>
          {!listLoaded && <div style={S.listNote}>Memuat percakapan…</div>}
          {listLoaded && conversations.length === 0 && (
            <div style={S.listNote}>
              {search || filter !== "all"
                ? "Tidak ada percakapan yang cocok."
                : "Belum ada percakapan WhatsApp. Pesan masuk dari Whatspie akan muncul di sini."}
            </div>
          )}
          {conversations.map((c) => {
            const active = c.id === activeId;
            const aiBusy = c.aiEnabled && c.aiState && c.aiState.status !== "idle";
            const chatStatus = CHAT_STATUS_OPTIONS.find((option) => option.value === c.status);
            const statusValue = chatStatus ? chatStatus.value : "open";
            return (
              <button
                key={c.id}
                className="ib-item"
                aria-current={active ? "true" : undefined}
                disabled={sending}
                onClick={() => openConversation(c.id)}
              >
                <Avatar name={c.name} phone={c.phone} />
                <span style={S.itemMain}>
                  <span style={S.itemTop}>
                    <span style={{ ...S.itemName, fontWeight: c.unread > 0 ? 700 : 600 }}>{c.name}</span>
                    <span style={S.itemTime}>{listTime(c.updatedAt)}</span>
                  </span>
                  <span style={S.itemBottom}>
                    <span style={{ ...S.itemPreview, color: c.unread > 0 ? C.ink : C.muted }}>
                      {previewOf(c)}
                    </span>
                    {c.unread > 0 && (
                      <span style={S.unreadBadge} aria-label={`${c.unread} pesan belum dibaca`}>
                        {c.unread}
                      </span>
                    )}
                  </span>
                  <span style={S.itemTags}>
                    {!c.aiEnabled ? (
                      <span style={{ ...S.tag, ...S.tagAgent }}>Agen</span>
                    ) : aiBusy ? (
                      <span style={{ ...S.tag, ...S.tagBusy }}>AI akan menjawab</span>
                    ) : null}
                    <span
                      style={{
                        ...S.tag,
                        ...S.tagStatus,
                        ...(statusValue === "pending"
                          ? S.tagStatusPending
                          : statusValue === "resolved"
                            ? S.tagStatusResolved
                            : S.tagStatusOpen),
                      }}
                    >
                      {chatStatus ? chatStatus.label : "Terbuka"}
                    </span>
                  </span>
                </span>
              </button>
            );
          })}
        </nav>
      </div>

      {/* ===== Percakapan ===== */}
      <section className="ib-chat" aria-label="Percakapan">
        {!activeId ? (
          <div style={S.empty}>
            <div style={S.emptyTitle}>Pilih percakapan</div>
            <div style={S.emptyText}>
              Pilih salah satu percakapan di sebelah kiri untuk membaca dan membalas pesan pelanggan.
            </div>
          </div>
        ) : (
          <>
            <header className="ib-chat-header" style={S.chatHeader}>
              <button
                className="ib-back ib-focusable"
                style={S.backBtn}
                aria-label="Kembali ke daftar percakapan"
                onClick={() => setMobileView("list")}
              >
                ←
              </button>
              {detail && <Avatar name={detail.conversation.name} phone={detail.conversation.phone} size={40} />}
              <div style={S.chatTitleBox}>
                <div style={S.chatName}>{detail ? detail.conversation.name : "Memuat…"}</div>
                <div style={S.chatPhone}>{detail ? formatPhone(detail.conversation.phone) : ""}</div>
              </div>
              {detail && (
                <>
                  <StatusChip aiEnabled={aiEnabled} aiState={detail.aiState} receivedAt={detailAt} />
                  <div role="group" aria-label="Siapa yang menjawab" style={S.segment}>
                    <button
                      className="ib-focusable"
                      aria-pressed={aiEnabled}
                      disabled={togglingMode}
                      style={{ ...S.segBtn, ...(aiEnabled ? S.segBtnOn : null) }}
                      onClick={() => changeMode(true)}
                    >
                      AI
                    </button>
                    <button
                      className="ib-focusable"
                      aria-pressed={!aiEnabled}
                      disabled={togglingMode}
                      style={{ ...S.segBtn, ...(!aiEnabled ? S.segBtnOn : null) }}
                      onClick={() => changeMode(false)}
                    >
                      Agen
                    </button>
                  </div>
                </>
              )}
            </header>

            {chatOffline && (
              <div style={S.offlineBar} role="status">
                Koneksi terputus — mencoba menyambung lagi…
              </div>
            )}

            <div
              ref={scrollRef}
              onScroll={handleScroll}
              className="ib-scroll ib-messages"
              style={S.messages}
              role="log"
              aria-label="Pesan"
            >
              {chatLoading && !detail && <div style={S.listNote}>Memuat pesan…</div>}
              {loadError && !detail && (
                <div style={S.errorBox} role="alert">
                  {loadError}
                </div>
              )}
              {detail && rows.length === 0 && <div style={S.listNote}>Belum ada pesan.</div>}
              {rows.map((r) =>
                r.type === "day" ? (
                  <div key={r.key} style={S.dayRow}>
                    <span style={S.dayChip}>{r.label}</span>
                  </div>
                ) : (
                  <Bubble key={r.key} m={r.m} />
                )
              )}
            </div>

            {actionError && (
              <div style={S.errorBox} role="alert">
                {actionError}
                <button
                  className="ib-focusable"
                  style={S.dismissBtn}
                  onClick={() => setActionError(null)}
                  aria-label="Tutup pesan galat"
                >
                  ×
                </button>
              </div>
            )}

            <div className="ib-composer" style={S.composer}>
              {emojiPickerOpen && (
                <div className="ib-emoji-picker" role="group" aria-label="Pilih emoji">
                  {CHAT_EMOJIS.map((emoji, index) => (
                    <button
                      key={`${emoji}-${index}`}
                      type="button"
                      className="ib-emoji-button ib-focusable"
                      aria-label={`Sisipkan emoji ${emoji}`}
                      title={emoji}
                      onClick={() => insertEmoji(emoji)}
                    >
                      {emoji}
                    </button>
                  ))}
                </div>
              )}
              {selectedFile && (
                <div className="ib-attachment-preview">
                  <span className="ib-attachment-name" title={selectedFile.name}>
                    📎 {selectedFile.name} · {formatFileSize(selectedFile.size)}
                  </span>
                  <button
                    type="button"
                    className="ib-attachment-remove ib-focusable"
                    aria-label="Hapus lampiran"
                    disabled={sending}
                    onClick={() => {
                      setSelectedFile(null);
                      setUploadedAttachment(null);
                      if (fileInputRef.current) fileInputRef.current.value = "";
                    }}
                  >
                    ×
                  </button>
                </div>
              )}
              <input
                ref={fileInputRef}
                type="file"
                accept={ATTACHMENT_ACCEPT}
                hidden
                disabled={!detail || sending}
                onChange={chooseAttachment}
              />
              <div style={S.composerRow}>
                <button
                  type="button"
                  className="ib-focusable"
                  style={S.emojiToggle}
                  aria-label="Lampirkan file atau foto"
                  title="Lampirkan file atau foto"
                  disabled={!detail || sending}
                  onClick={() => fileInputRef.current && fileInputRef.current.click()}
                >
                  📎
                </button>
                <button
                  type="button"
                  className="ib-focusable"
                  style={S.emojiToggle}
                  aria-label={emojiPickerOpen ? "Tutup pemilih emoji" : "Buka pemilih emoji"}
                  title="Pilih emoji"
                  aria-expanded={emojiPickerOpen}
                  disabled={!detail || sending}
                  onClick={() => setEmojiPickerOpen((open) => !open)}
                >
                  😊
                </button>
                <textarea
                  ref={textareaRef}
                  className="ib-focusable"
                  aria-label="Tulis balasan"
                  rows={1}
                  style={S.textarea}
                  placeholder="Tulis balasan sebagai agen…"
                  value={input}
                  disabled={!detail || sending}
                  onChange={(e) => setInput(e.target.value)}
                  onKeyDown={handleKeyDown}
                />
                <button
                  className="ib-focusable"
                  style={{ ...S.sendBtn, opacity: sending || (!input.trim() && !selectedFile) || !detail ? 0.5 : 1 }}
                  disabled={sending || (!input.trim() && !selectedFile) || !detail}
                  onClick={sendMessage}
                >
                  {sending ? "Mengirim…" : "Kirim"}
                </button>
              </div>
              <div style={S.composerHint}>
                {aiEnabled
                  ? "Mengirim balasan akan mengambil alih dari AI. Enter untuk kirim, Shift+Enter untuk baris baru."
                  : "Mode Agen: AI tidak menjawab otomatis. Pilih “AI” di atas untuk mengembalikannya."}
              </div>
            </div>
          </>
        )}
      </section>

      <aside className="ib-profile" aria-label="Profil kontak">
        {detail ? (
          <>
            <div className="ib-profile-cover">
              <div className="ib-profile-avatar" style={{ background: avatarColor(detail.conversation.name + detail.conversation.phone) }}>
                {initialOf(detail.conversation.name)}
              </div>
            </div>
            <div className="ib-profile-body">
              <h2 className="ib-profile-title">{detail.conversation.name}</h2>
              <div className="ib-profile-subtitle">Kontak pelanggan</div>
              <div className="ib-profile-pill"><span aria-hidden="true">●</span> WhatsApp</div>
              <section className="ib-profile-section">
                <div className="ib-profile-section-title">Informasi kontak</div>
                <div className="ib-profile-row">
                  <span className="ib-profile-label">Nama</span>
                  <span className="ib-profile-value">{detail.conversation.name}</span>
                </div>
                <div className="ib-profile-row">
                  <span className="ib-profile-label">Nomor telepon</span>
                  <span className="ib-profile-value">{formatPhone(detail.conversation.phone) || "—"}</span>
                </div>
                <div className="ib-profile-row">
                  <span className="ib-profile-label">Kanal</span>
                  <span className="ib-profile-value">WhatsApp</span>
                </div>
              </section>
              <section className="ib-profile-section">
                <div className="ib-profile-section-title">Percakapan</div>
                <label className="ib-profile-control-label" htmlFor="ib-chat-status">Status chat</label>
                <select
                  id="ib-chat-status"
                  className="ib-profile-control ib-focusable"
                  value={detail.conversation.status || "open"}
                  onChange={(event) => changeChatStatus(event.target.value)}
                  disabled={savingStatus}
                >
                  {CHAT_STATUS_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </select>
                <div className="ib-profile-row">
                  <span className="ib-profile-label">Penanganan</span>
                  <span className="ib-profile-value">{detail.conversation.aiEnabled ? "AI" : "Agen"}</span>
                </div>
                <div className="ib-profile-row">
                  <span className="ib-profile-label">Pesan dimuat</span>
                  <span className="ib-profile-value">{detail.messages.length}</span>
                </div>
                {detail.conversation.createdAt && (
                  <div className="ib-profile-row">
                    <span className="ib-profile-label">Mulai</span>
                    <span className="ib-profile-value">
                      {new Date(detail.conversation.createdAt).toLocaleDateString("id-ID", {
                        day: "numeric",
                        month: "short",
                        year: "numeric",
                      })}
                    </span>
                  </div>
                )}
              </section>
              <section className="ib-profile-section">
                <label className="ib-profile-section-title ib-profile-notes-title" htmlFor="ib-additional-notes">Additional Notes</label>
                <textarea
                  id="ib-additional-notes"
                  className="ib-profile-control ib-profile-notes ib-focusable"
                  value={noteDrafts[detail.conversation.id] ?? detail.conversation.additionalNotes ?? ""}
                  maxLength={5000}
                  placeholder="Tambahkan catatan internal untuk percakapan ini…"
                  disabled={savingNotes}
                  onChange={(event) =>
                    setNoteDrafts((current) => ({ ...current, [detail.conversation.id]: event.target.value }))
                  }
                />
                <button
                  className="ib-profile-save ib-focusable"
                  onClick={saveAdditionalNotes}
                  disabled={
                    savingNotes ||
                    (noteDrafts[detail.conversation.id] ?? detail.conversation.additionalNotes ?? "") ===
                      (detail.conversation.additionalNotes || "")
                  }
                >
                  {savingNotes ? "Menyimpan…" : "Simpan catatan"}
                </button>
                {profileError && <div className="ib-profile-error" role="alert">{profileError}</div>}
                <div className="ib-profile-feedback">Catatan ini hanya terlihat oleh agen dan admin.</div>
              </section>
            </div>
          </>
        ) : (
          <div className="ib-profile-empty">Pilih percakapan untuk melihat profil dan informasi kontak.</div>
        )}
      </aside>
        </>
      )}
    </div>
  );
}

const S = {
  forbidden: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 12,
    padding: 40,
    background: "#fff",
    border: `1px solid ${C.line}`,
    fontFamily: "'Inter', sans-serif",
    textAlign: "center",
  },
  /* daftar */
  listHeader: { padding: "18px 22px 16px", borderBottom: `1px solid ${C.line}`, background: "#fff" },
  topRow: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 18 },
  brandRow: { display: "flex", alignItems: "center", gap: 8, marginBottom: 16, color: C.muted, fontSize: 10, fontWeight: 700, letterSpacing: ".12em" },
  brandMark: { display: "inline-flex", alignItems: "center", justifyContent: "center", width: 25, height: 25, borderRadius: 8, background: C.green, color: "#fff", fontSize: 9, letterSpacing: 0 },
  userBox: { display: "flex", alignItems: "center", gap: 8, minWidth: 0 },
  userName: {
    fontSize: 12.5,
    color: C.soft,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: 160,
  },
  linkBtn: {
    border: "none",
    background: "transparent",
    color: C.soft,
    fontSize: 12.5,
    cursor: "pointer",
    padding: "6px 8px",
    borderRadius: 8,
    fontFamily: "'Inter', sans-serif",
  },
  titleRow: { display: "flex", alignItems: "center", gap: 9, marginBottom: 14 },
  title: { margin: 0, fontWeight: 700, fontSize: 21, letterSpacing: "-0.03em", color: C.ink },
  totalBadge: {
    background: C.greenBg,
    fontSize: 11.5,
    fontWeight: 600,
    borderRadius: 999,
    padding: "2px 8px",
    color: C.green,
  },
  search: {
    width: "100%",
    border: `1px solid ${C.line}`,
    background: C.paper,
    borderRadius: 12,
    padding: "11px 13px",
    fontSize: 13,
    fontFamily: "'Inter', sans-serif",
    color: C.ink,
    marginBottom: 13,
  },
  filters: { display: "flex", gap: 6, flexWrap: "wrap" },
  filterBtn: {
    border: `1px solid transparent`,
    background: C.paper,
    color: C.soft,
    fontSize: 12,
    padding: "7px 12px",
    borderRadius: 999,
    cursor: "pointer",
    fontFamily: "'Inter', sans-serif",
  },
  filterBtnOn: { background: C.indigo, color: "#fff", borderColor: C.indigo },
  filterCount: { opacity: 0.75, marginLeft: 2 },
  listBody: { flex: 1 },
  listNote: { padding: "24px 20px", fontSize: 13, color: C.muted, lineHeight: 1.6 },
  listError: { margin: "8px 14px 0", padding: "8px 10px", borderRadius: 10, background: C.dangerBg, color: C.danger, fontSize: 12.5 },
  avatarWrap: { position: "relative", display: "inline-block", flexShrink: 0 },
  avatar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    color: "#F1F8F4",
    fontWeight: 600,
  },
  channelDot: {
    position: "absolute",
    right: -3,
    bottom: -3,
    background: "#24A56A",
    color: "#fff",
    fontSize: 8,
    fontWeight: 700,
    borderRadius: 999,
    padding: "1px 3px",
    border: "2px solid #F5F8F6",
    lineHeight: 1.1,
  },
  itemMain: { display: "flex", flexDirection: "column", gap: 5, minWidth: 0, flex: 1 },
  itemTop: { display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 8 },
  itemName: { fontSize: 14, color: C.ink, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
  itemTime: { fontSize: 11.5, color: C.muted, flexShrink: 0 },
  itemBottom: { display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 },
  itemPreview: { fontSize: 12.5, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", minWidth: 0 },
  unreadBadge: {
    background: C.green,
    color: "#fff",
    fontSize: 11,
    fontWeight: 600,
    borderRadius: 999,
    minWidth: 20,
    textAlign: "center",
    padding: "1px 6px",
    flexShrink: 0,
  },
  itemTags: { display: "flex", gap: 6, marginTop: 2 },
  tag: { fontSize: 10.5, fontWeight: 600, borderRadius: 6, padding: "1px 6px" },
  tagAgent: { background: C.amberBg, color: C.amber },
  tagBusy: { background: C.greenBg, color: C.green },
  tagStatus: { background: "#E8EDF8", color: "#435A8A" },
  tagStatusOpen: { background: C.greenBg, color: C.green },
  tagStatusPending: { background: C.amberBg, color: C.amber },
  tagStatusResolved: { background: C.paper, color: C.muted },
  /* chat */
  empty: { margin: "auto", textAlign: "center", padding: 32, maxWidth: 440 },
  emptyTitle: { fontWeight: 700, fontSize: 21, color: C.ink, marginBottom: 8, letterSpacing: "-0.02em" },
  emptyText: { fontSize: 13.5, color: C.muted, lineHeight: 1.55 },
  primaryBtn: {
    border: "none",
    background: C.indigo,
    color: "#fff",
    fontSize: 14,
    fontWeight: 500,
    padding: "10px 18px",
    borderRadius: 10,
    cursor: "pointer",
    fontFamily: "'Inter', sans-serif",
  },
  chatHeader: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "15px 22px",
    borderBottom: `1px solid ${C.line}`,
    flexWrap: "wrap",
  },
  backBtn: {
    border: `1px solid ${C.line}`,
    background: "#fff",
    borderRadius: 10,
    width: 34,
    height: 34,
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    fontSize: 16,
  },
  chatTitleBox: { flex: 1, minWidth: 120 },
  chatName: {
    fontWeight: 700,
    fontSize: 15,
    color: C.ink,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  chatPhone: { fontSize: 12.5, color: C.muted, marginTop: 1 },
  chip: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    fontSize: 12,
    fontWeight: 600,
    borderRadius: 999,
    padding: "4px 10px",
    whiteSpace: "nowrap",
  },
  chipDot: { width: 7, height: 7, borderRadius: "50%", background: "currentColor", display: "inline-block" },
  chipAi: { background: C.greenBg, color: C.green },
  chipBusy: { background: "#E6F0F7", color: "#2A5C80" },
  chipAgent: { background: C.amberBg, color: C.amber },
  segment: { display: "flex", padding: 3, background: C.paper, border: `1px solid ${C.line}`, borderRadius: 11, gap: 2 },
  segBtn: {
    border: "none",
    background: "transparent",
    color: C.soft,
    fontSize: 12.5,
    fontWeight: 500,
    padding: "6px 14px",
    borderRadius: 9,
    cursor: "pointer",
    fontFamily: "'Inter', sans-serif",
  },
  segBtnOn: { background: C.indigo, color: "#fff" },
  offlineBar: { padding: "6px 16px", background: C.amberBg, color: C.amber, fontSize: 12.5 },
  messages: {
    flex: 1,
    padding: "24px clamp(18px, 4vw, 64px)",
    display: "flex",
    flexDirection: "column",
    gap: 10,
    backgroundColor: "#F2F7F4",
    backgroundImage: "radial-gradient(#DDE9E2 0.7px, transparent 0.7px)",
    backgroundSize: "18px 18px",
  },
  dayRow: { display: "flex", justifyContent: "center", margin: "6px 0" },
  dayChip: { fontSize: 11.5, color: C.muted,   background: "#fff",
  boxShadow: "0 1px 3px rgba(23,42,37,.08)", borderRadius: 999, padding: "3px 12px" },
  bubble: {
    maxWidth: "68%",
    padding: "10px 14px 8px",
    borderRadius: 16,
    fontSize: 14,
    lineHeight: 1.55,
  },
  bubbleCustomer: { background: "#fff", color: C.ink, borderBottomLeftRadius: 4, boxShadow: "0 2px 5px rgba(23,42,37,.06)" },
  bubbleAi: { background: "#DDF3E8", color: C.ink, borderBottomRightRadius: 4, boxShadow: "0 2px 5px rgba(23,42,37,.05)" },
  bubbleAgent: { background: C.agent, color: "#F1F7F4", borderBottomRightRadius: 4 },
  bubbleLabel: { fontSize: 10.5, fontWeight: 700, letterSpacing: "0.04em", textTransform: "uppercase", opacity: 0.75, marginBottom: 2 },
  bubbleText: { whiteSpace: "pre-wrap", wordBreak: "break-word" },
  bubbleTime: { fontSize: 10.5, opacity: 0.65, textAlign: "right", marginTop: 3 },
  errorBox: {
    margin: "0 16px 8px",
    padding: "8px 12px",
    background: C.dangerBg,
    color: C.danger,
    fontSize: 13,
    borderRadius: 10,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 8,
  },
  dismissBtn: { border: "none", background: "transparent", color: C.danger, fontSize: 18, cursor: "pointer", lineHeight: 1 },
  composer: { padding: "14px 22px 16px", borderTop: `1px solid ${C.line}`, background: "#fff" },
  composerRow: { display: "flex", gap: 10, alignItems: "flex-end" },
  emojiToggle: {
    flex: "0 0 42px",
    width: 42,
    height: 42,
    border: `1px solid ${C.line}`,
    borderRadius: 11,
    background: C.paper,
    fontSize: 22,
    cursor: "pointer",
  },
  textarea: {
    flex: 1,
    resize: "none",
    border: `1px solid ${C.line}`,
    borderRadius: 12,
    padding: "11px 14px",
    fontSize: 14,
    fontFamily: "'Inter', sans-serif",
    color: C.ink,
    maxHeight: 140,
    lineHeight: 1.5,
  },
  sendBtn: {
    border: "none",
    background: C.agent,
    color: "#fff",
    fontSize: 14,
    fontWeight: 500,
    padding: "11px 20px",
    borderRadius: 12,
    cursor: "pointer",
    fontFamily: "'Inter', sans-serif",
  },
  composerHint: { fontSize: 11.5, color: C.muted, marginTop: 6 },
};
